// Components
const ModalAddUser = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-notification-body" */ '@/app/views/main-view/app-sharing/modals/modal-add-user/modal-add-user.vue');
const ModalTransferPrimaryUser = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-notification-body" */ '@/app/views/main-view/app-sharing/modals/modal-transfer-primary-user/modal-transfer-primary-user.vue');

// Mixins
import { userMixins } from '@/app/mixins/modules/user-mixins.js';
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { switchPetMixins } from '@/app/mixins/modules/switch-pet-mixins';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

// Constants
import { STATUS_CODES, SUCCESS_MSG } from '@/app/constants/status-constants';

// Services
import userService from '@/app/services/main/user/user-service.js';

export default {
    name: 'AppSharingContainer',
    components: {
        ModalAddUser,
        ModalTransferPrimaryUser
    },
    mixins: [
        toastMessageMixins,
        userMixins,
        tableMixins,
        switchPetMixins
    ],
    data() {
        return {
            // loaders
            isAPILoading: false,
            isAddModalLoading: false,
            // table
            theads: [
                { name: 'First Name', sortLabel: 'firstName', isDesc: false, style: 'min-width: 15%;', hasSearch: true, searchLabel: 'f_firstName'},
                { name: 'Last Name', sortLabel: 'lastName', isDesc: false, style: 'min-width: 15%;', hasSearch: true, searchLabel: 'f_lastName'},
                { name: 'Email', sortLabel: 'emailAddress', isDesc: false, style: 'min-width: 20%;', hasSearch: true, searchLabel: 'f_emailAddress'},
                { name: 'Status', sortLabel: 'status', isDesc: false, style: 'min-width: 300px;', hasStatusSearch: true, searchLabel: 'f_status'}
            ],
            // sorting
            desc: true,
            // modal
            modalContent: null,
            statusList: [
                { name: 'Active', code: 'A', value: 'ACTIVE'},
                { name: 'Inactive', code: 'I', value: 'INACTIVE' },
                { name: 'Pending', code: 'P', value: 'PENDING' }
            ],
            selectedStatus: '',
            custId: null,
            primaryUser: false
        }
    },
    created() {
        this.columnsFilter['f_status'] = this.selectedStatus;
        this.getTableContent(this.page, this.limit, this.sortBy, this.desc = true);
    },
    methods: {
        refreshActivePetData() {
            this.columnsFilter['f_status'] = this.selectedStatus;
            this.getTableContent(this.page, this.limit, this.sortBy, this.desc = true);
        },
        getTableContent(page = this.page, limit = this.isDashboard ? 5 : this.limit, sortBy = this.sortBy, desc = this.desc) {
            this.getUserList({ page, limit, sortBy, desc });
        },
        getUserList(queryParams) {
            const { customerId, id } = this.getUserDetails();
            
            queryParams['f_customerId'] = customerId;
            
            this.custId = id;

            if (this.columnsFilter['f_emailAddress']) {
                queryParams['f_emailAddress'] = this.columnsFilter['f_emailAddress'];
            }

            if (this.columnsFilter['f_lastName']) {
                queryParams['f_lastName'] = this.columnsFilter['f_lastName'];
            }

            if (this.columnsFilter['f_firstName']) {
                queryParams['f_firstName'] = this.columnsFilter['f_firstName'];
            }

            if (this.columnsFilter['f_status']) {
                queryParams['f_status'] = this.columnsFilter['f_status'];
            }
            

            this.isAPILoading = true;
            userService.getUserList(queryParams)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        if(res.data.data.length!==0){
                            if(res.data.data[0].primaryUserId === id){
                                this.primaryUser = true;
                            }else{
                                this.primaryUser = false;
                            }
                        }
                        
                        this.tableContent = {
                            tableData: res.data.data,
                            paginationData: res.data.pagination
                        };

                        this.isAPILoading = false;
                    } else {
                        this.showGenericErrorToast();
                    }
                });
        },
        refreshTableContent() {
            this.getTableContent(this.page, this.limit, null, true);
        },
        setUserStatus(event, user) {
            const title = event.target.checked ? `Are you sure you want to activate ${user.firstName} ${user.lastName}?` : `Are you sure you want to deactivate ${user.firstName} ${user.lastName}?`;
            
            const toastContent = event.target.checked ? `Successfully activate ${user.firstName} ${user.lastName}!` : `Successfully deactivate ${user.firstName} ${user.lastName}!`;

            const userDetails = {
                "status": event.target.checked ? "A" : "I"
            }

            this.setUserStatusAPI(user, title, toastContent, userDetails, event)
        },
        setUserStatusAPI(user, title, toastContent, userDetails, event) {
            this.$swal({
                imageHeight: '30px',
                title,
                imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
                confirmButtonText: 'Confirm',
                showCancelButton: true,
                cancelButtonText: 'Cancel',
                reverseButtons: true
            })
            .then(result => {
                if (result.value) {
                    userService.putUserStatus(user.id, userDetails)
                        .then(res => {
                            if (res.status === STATUS_CODES.SUCCESS) {
                                this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, toastContent);
                                this.refreshTableContent();

                                if(userDetails.status !== 'R') {
                                    event.target.checked = !event.target.checked;
                                }
                            } else {
                                this.showAPIErrorToast(null, res);
                                
                                if(userDetails.status !== 'R') {
                                    event.target.checked = !event.target.checked;
                                }
                            }
                        });
                } else if (userDetails.status !== 'R') {
                    event.target.checked = !event.target.checked;
                }
            });
        },
        removeUser(user) {
            if (user.status !== 'P') {
                return;
            }

            const title = `Are you sure you want to remove ${user.firstName} ${user.lastName}?`;

            const toastContent = `Successfully removed ${user.firstName} ${user.lastName}!`;

            const userDetails = {
                "status": 'R'
            } 

            this.setUserStatusAPI(user, title, toastContent, userDetails);
        },
        resendLink(user) {
            if (user.status !== 'P') {
                return;
            }

            this.$swal({
                imageHeight: '30px',
                title: `Are you sure you want to resend link to email ${user.firstName} ${user.lastName}?`,
                imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
                confirmButtonText: 'Confirm',
                showCancelButton: true,
                cancelButtonText: 'Cancel',
                reverseButtons: true
            })
            .then(result => {
                if (result.value) {
                    userService.resendLink(user.emailAddress)
                        .then(res => {
                            if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                                this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, `Activaion link was sent to ${user.emailAddress}.`);
                            } else {
                                this.showAPIErrorToast(null, res);
                            }
                        });
                } 
            });
        },
        showAddUserModal() {
			this.$refs.modalAddUser.show();
		},
        showTransferPrimaryUserModal() {
			this.$refs.modalTransferPrimaryUser.openModal();
		}
    }
}